import React from 'react'
import SuggestionsForm from '../components/SuggestionsForm/'
import Helmet from 'react-helmet'

const SuggestionsEs = () => (
  <div className="page suggestions">

  <Helmet
                title={`Envíenos sus sugerencias | Budget Nicaragua`}
                meta={[
                  {
                    name: 'description',
                    content:
                      'Preguntas frecuentes sobre el alquiler de autos. ',
                  },
                ]}
                link={[
                  {
                    rel: 'alternate',
                    hreflang: 'es',
                    href:
                      './en/suggestions',
                  },
                ]}
              />

  
    <div className="image" />
    <h1>Sugerencias</h1>
    <div className="grid-wrapper">
      <div className="block-first">
        <SuggestionsForm lan="es" />
      </div>
      <div className="block-second">
        <h3>
          Queremos que su viaje con Budget Car and Truck Rental sea su mejor
          experiencia.
        </h3>
        <a className="mail" href="mailto:feedback@budget.com.ni ">
        feedback@budget.com.ni 
        </a>
        <a href="tel:+50522559000">+505 2255-9000</a>   
      </div>
    </div>
  </div>
)
export default SuggestionsEs



// WEBPACK FOOTER //
// ./src/pages/suggestions.es.js